import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Dialog, DialogBody, DialogFooter } from '@blueprintjs/core';
import { css } from '@emotion/react';
import { Formik } from 'formik';
import { useRef } from 'react';
import { DataExportStage, exportAsJcamp, } from '../../data/SpectraManager';
import { useToaster } from '../context/ToasterContext';
import ActionButtons from '../elements/ActionButtons';
import FormikCheckBox from '../elements/formik/FormikCheckBox';
import FormikSelect from '../elements/formik/FormikSelect';
const initValues = {
    onlyReal: true,
    dataExportStage: 'PROCESSED',
};
const styles = {
    container: {
        width: '25em',
        padding: '1.5em 3em',
        display: 'flex',
        flexDirection: 'column',
    },
    row: {
        display: 'flex',
        paddingBottom: '0.5em',
    },
    label: {
        flex: 6,
        fontSize: '1em',
        fontWeight: 'bold',
    },
    innerContainer: {
        flex: 6,
        justifyContent: 'flex-start',
    },
};
const DATA_STAGES = Object.keys(DataExportStage).map((key) => ({
    label: key,
    value: DataExportStage[key],
}));
function ExportAsJcampModal(props) {
    const { closeDialog, spectrum } = props;
    const refForm = useRef(null);
    const toaster = useToaster();
    function submitHandler(options) {
        const hideLoading = toaster.showLoading({
            message: 'export as JCAMP-DX in progress',
        });
        try {
            exportAsJcamp(spectrum, options);
        }
        catch (error) {
            toaster.show({ message: error.message, intent: 'danger' });
        }
        finally {
            closeDialog?.();
            hideLoading();
        }
    }
    return (_jsxs(Dialog, { isOpen: true, onClose: closeDialog, title: "Export as JCAMP", children: [_jsx(DialogBody, { css: css `
          background-color: white;
        `, children: _jsx(Formik, { innerRef: refForm, initialValues: initValues, onSubmit: submitHandler, children: _jsxs("div", { style: styles.container, children: [_jsxs("div", { style: styles.row, children: [_jsx("span", { style: styles.label, children: " Data " }), _jsx("div", { style: styles.innerContainer, children: _jsx(FormikSelect, { name: "dataExportStage", items: DATA_STAGES, style: { width: '100%' } }) })] }), _jsxs("div", { style: styles.row, children: [_jsx("span", { style: styles.label, children: " Only real " }), _jsx("div", { style: styles.innerContainer, children: _jsx(FormikCheckBox, { name: "onlyReal" }) })] })] }) }) }), _jsx(DialogFooter, { children: _jsx("div", { style: { display: 'flex', justifyContent: 'flex-end' }, children: _jsx(ActionButtons, { style: { flexDirection: 'row-reverse', margin: 0 }, onDone: () => refForm.current?.submitForm(), doneLabel: "export", onCancel: () => {
                            closeDialog?.();
                        } }) }) })] }));
}
export default ExportAsJcampModal;
